<template>
    <div class="container-fluid">
        <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>

        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <span slot="header"><icon name="user" scale="1"></icon> User Profile</span>
                    <div class="row">
                        <div class="col-md-4" align="center" style="padding-top: 25px;">
                            <icon name="user-circle" scale="8"></icon>
                            <h5>{{$store.state.user.profile.name}}</h5>
                            <span v-if="profile.admin === 1"><b-badge variant="success">ADMINISTRATOR</b-badge></span>
                            <p>
                                <span v-if="profile.designation">{{profile.designation}} <br/> </span>
                                {{company}}
                            </p>
                            <button @click="$refs.changeProfile.show()"  class="btn btn-sm btn-secondary" style="margin-top: 10px;"> <icon name="pencil" scale="1"></icon> Update Profile</button>
                            <br/>
                            <button @click="$refs.changeAddress.show()"  class="btn btn-sm btn-secondary" style="margin-top: 10px;"> <icon name="map-marker" scale="1"></icon> Update Address</button>
                            <br/>
                            <button @click="$refs.changePassword.show()"  class="btn btn-sm btn-secondary" style="margin-top: 10px; margin-bottom: 10px;"> <icon name="lock" scale="1"></icon> Change Password</button>
                        </div>
                        <div class="col-md-8">
                            <div class="row">
                                <div class="col-md-12 heading-background" style="margin-bottom: 15px;">
                                    Contact Information
                                </div>
                                <div class="col-md-3 col-sm-6">Email:</div>
                                <div class="col-md-9 col-sm-6">{{profile.email}}</div>
                                <div v-if="profile.telephone" class="col-md-3 col-sm-6">Telephone:</div>
                                <div v-if="profile.telephone" class="col-md-9 col-sm-6">{{profile.telephone}}</div>
                                <div v-if="profile.mobile" class="col-md-3 col-sm-6">Mobile:</div>
                                <div v-if="profile.mobile" class="col-md-9 col-sm-6">{{profile.mobile}}</div>
                                <div v-if="address" class="col-md-3 col-sm-6">Address:</div>
                                <div v-if="address" class="col-md-9 col-sm-6">
                                    <span v-if="address.addressLine1">{{address.addressLine1}}. </span>
                                    <span v-if="address.addressLine2">{{address.addressLine2}}. </span>
                                    <span v-if="address.city">{{address.city}}. </span>
                                    <span v-if="address.county">{{address.county}}. </span>
                                    <span v-if="address.stateOrProvince">{{address.stateOrProvince}}. </span>
                                    <span v-if="address.postalCode">{{address.postalCode}}. </span>
                                    <span v-if="address.country">{{address.country}}. </span>
                                </div>
                                <div class="col-md-12 heading-background" style="margin-top: 15px; margin-bottom: 15px;">
                                    General Information
                                </div>
                                <div v-if="profile.designation" class="col-md-3 col-sm-6">Designation:</div>
                                <div v-if="profile.designation" class="col-md-9 col-sm-6">{{profile.designation.name}}</div>
                                <div class="col-md-3 col-sm-6">Business Unit:</div>
                                <div class="col-md-9 col-sm-6">{{unit}}</div>
                                <div v-if="profile.designation" class="col-md-3 col-sm-6">Manager:</div>
                                <div v-if="profile.designation" class="col-md-9 col-sm-6">{{manager}}</div>
                                <div class="col-md-3 col-sm-6">Status:</div>
                                <div class="col-md-9 col-sm-6">
                                    <span v-if="profile.active === 1"><b-badge variant="success">ACTIVE</b-badge></span>
                                    <span v-if="profile.active === 0"><b-badge variant="danger">INACTIVE</b-badge></span>
                                </div>
                                <div class="col-md-12 heading-background" style="margin-top: 15px; margin-bottom: 15px;">
                                    Additional Information
                                </div>
                                <div v-if="timezone" class="col-md-3 col-sm-6">Timezone:</div>
                                <div v-if="timezone" class="col-md-9 col-sm-6">{{timezone}}</div>
                                <div v-if="timeformat" class="col-md-3 col-sm-6">Time Format:</div>
                                <div v-if="timeformat" class="col-md-9 col-sm-6">{{timeformat}}</div>
                                <div v-if="language" class="col-md-3 col-sm-6">Language:</div>
                                <div v-if="language" class="col-md-9 col-sm-6">{{language}}</div>

                            </div>
                        </div>
                    </div>

                </b-card>
            </div>
        </div>











        <form @submit.prevent="onProfileSubmit"
              @keydown="profile2.errors.clear($event.target.name)"
              @change="profile2.errors.clear($event.target.name)"
              @click.right="profile2.errors.clear($event.target.name)"
        >
            <b-modal ref="changeProfile" size="lg" centered >
            <div slot="modal-header">
                <h3>Update Your Profile</h3>
            </div>

            <b-container fluid>
                <p>Please use the form below to update your profile.</p>
                <div class="form-group row">
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Name:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('name')}" v-model="profile2.name"  id="name" type="text" class="form-control" placeholder="Your Name">
                        <span class="help is-danger" v-if="profile2.errors.has('name')" v-text="profile2.errors.get('name')"></span>
                    </div>
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Email:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('email')}" v-model="profile2.email" type="text" class="form-control" id="email" placeholder="Email Address">
                        <span class="help is-danger" v-if="profile2.errors.has('email')" v-text="profile2.errors.get('email')"></span>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Telephone Number:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('telephone')}" v-model="profile2.telephone" type="text" class="form-control" title="telephone" placeholder="Landline number">
                        <span class="help is-danger" v-if="profile2.errors.has('telephone')" v-text="profile2.errors.get('telephone')"></span>
                    </div>
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Mobile Number:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('mobile')}" v-model="profile2.mobile" type="text" class="form-control" title="mobile" placeholder="Mobile number">
                        <span class="help is-danger" v-if="profile2.errors.has('mobile')" v-text="profile2.errors.get('mobile')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Business Unit:</strong></small>
                        <select :class="{'is-danger-input': profile2.errors.has('units_id')}"  class="form-control" v-model="profile2.units_id">
                            <option v-for="unit in $store.getters['environment/getUnits']" v-bind:value="unit.id">
                                {{unit.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="profile2.errors.has('units_id')" v-text="profile2.errors.get('units_id')"></span>
                    </div>
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Manager:</strong></small>
                        <select :class="{'is-danger-input': profile2.errors.has('manager')}" class="form-control" v-model="profile2.manager">
                            <option v-for="managerx in $store.getters['user/getUsers']" v-bind:value="managerx.id">
                                {{managerx.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="profile2.errors.has('manager')" v-text="profile2.errors.get('manager')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Recovery Email Address:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('recoveryEmail')}" v-model="profile2.recoveryEmail" type="text" class="form-control" id="recoveryEmail" placeholder="Recovery Email">
                        <span class="help is-danger" v-if="profile2.errors.has('recoveryEmail')" v-text="profile2.errors.get('recoveryEmail')"></span>
                    </div>
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Designation:</strong></small>
                        <input :class="{'is-danger-input': profile2.errors.has('designation')}" v-model="profile2.designation" type="text" class="form-control" id="designation" placeholder="Your Job Role">
                        <span class="help is-danger" v-if="profile2.errors.has('designation')" v-text="profile2.errors.get('designation')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Choose Your Language:</strong></small>
                        <select :class="{'is-danger-input': profile2.errors.has('language')}" class="form-control" v-model="profile2.language">
                            <option v-for="languagex in $store.getters['environment/getLanguages']" v-bind:value="languagex.id">
                                {{languagex.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="profile2.errors.has('language')" v-text="profile2.errors.get('language')"></span>
                    </div>

                    <div class="col-sm-6">
                        <small class="form-text text-muted"><strong>Choose Time Format:</strong></small>
                        <select :class="{'is-danger-input': profile2.errors.has('timeFormat')}" class="form-control" v-model="profile2.timeFormat">
                            <option v-for="timeformatx in $store.getters['environment/getTimeformats']" v-bind:value="timeformatx.id">
                                {{timeformatx.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="profile2.errors.has('timeFormat')" v-text="profile2.errors.get('timeFormat')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <small class="form-text text-muted"><strong>Preferred Time Zone:</strong></small>
                        <select :class="{'is-danger-input': profile2.errors.has('timezone')}" class="form-control" v-model="profile2.timezone">
                            <option v-for="timezonex in $store.getters['environment/getTimezones']" v-bind:value="timezonex.id">
                                {{timezonex.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="profile2.errors.has('timezone')" v-text="profile2.errors.get('timezone')"></span>
                    </div>
                </div>

            </b-container>

            <div slot="modal-footer">
                <button class="btn btn-success float-right" type="submit"><icon name="user"></icon> Update Profile</button>
                <button class="btn btn-dark float-right" type="button" style="margin-right: 5px;" @click="$refs.changeProfile.hide()"><icon name="times"></icon> Cancel</button>
            </div>
        </b-modal>
        </form>





        <form @submit.prevent="onAddressSubmit"
              @keydown="address2.errors.clear($event.target.name)"
              @change="address2.errors.clear($event.target.name)"
              @click.right="address2.errors.clear($event.target.name)"
        >
            <b-modal ref="changeAddress" size="lg" centered >
            <div slot="modal-header">
                <h3>Update Your Address</h3>
            </div>

            <b-container fluid>
                <p>Please use the form below to change your address.</p>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <small class="form-text text-muted"><strong>Your Address:</strong></small>
                        <input :class="{'is-danger-input': address2.errors.has('addressLine1')}" v-model="address2.addressLine1" type="text" class="form-control" id="addressLine1" placeholder="Address Line 1">
                        <span class="help is-danger" v-if="address2.errors.has('addressLine1')" v-text="address2.errors.get('addressLine1')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <small class="form-text text-muted"><strong>&nbsp;</strong></small>
                        <input :class="{'is-danger-input': address2.errors.has('addressLine2')}" v-model="address2.addressLine2" type="text" class="form-control" id="addressLine2" placeholder="Address Line 2">
                        <span class="help is-danger" v-if="address2.errors.has('addressLine2')" v-text="address2.errors.get('addressLine2')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-4">
                        <small class="form-text text-muted"><strong>City:</strong></small>
                        <input :class="{'is-danger-input': address2.errors.has('city')}" v-model="address2.city" type="text" class="form-control" id="city" placeholder="City">
                        <span class="help is-danger" v-if="address2.errors.has('city')" v-text="address2.errors.get('city')"></span>
                    </div>
                    <div class="col-sm-4">
                        <small class="form-text text-muted"><strong>County:</strong></small>
                        <input :class="{'is-danger-input': address2.errors.has('county')}" v-model="address2.county" type="text" class="form-control" id="county" placeholder="City">
                        <span class="help is-danger" v-if="address2.errors.has('county')" v-text="address2.errors.get('county')"></span>
                    </div>
                    <div class="col-sm-4">
                        <small class="form-text text-muted"><strong>Zip Code:</strong></small>
                        <input :class="{'is-danger-input': address2.errors.has('postalCode')}" v-model="address2.postalCode" type="text" class="form-control" id="postalCode" placeholder="Zip Code / Postcode">
                        <span class="help is-danger" v-if="address2.errors.has('postalCode')" v-text="address2.errors.get('postalCode')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-12">
                        <small class="form-text text-muted"><strong>Country:</strong></small>
                        <select :class="{'is-danger-input': address2.errors.has('country')}" class="form-control" v-model="address2.country">
                            <option v-for="countryx in $store.getters['environment/getCountries']" v-bind:value="countryx.countryCode">
                                {{countryx.name}}
                            </option>
                        </select>
                        <span class="help is-danger" v-if="address2.errors.has('country')" v-text="address2.errors.get('country')"></span>
                    </div>
                </div>

            </b-container>

            <div slot="modal-footer">
                <button class="btn btn-success float-right" type="submit"><icon name="map-marker"></icon> Update Address</button>
                <button class="btn btn-dark float-right" type="button" style="margin-right: 5px;" @click="$refs.changeAddress.hide()"><icon name="times"></icon> Cancel</button>
            </div>
        </b-modal>
        </form>






        <form @submit.prevent="onPasswordChange"
              @keydown="password.errors.clear($event.target.name)"
              @change="password.errors.clear($event.target.name)"
              @click.right="password.errors.clear($event.target.name)"
        >
            <b-modal ref="changePassword" size="lg" centered >
            <div slot="modal-header">
                <h3>Change Your Password</h3>
            </div>

            <b-container fluid>
                <p>Please use the form below to change your password.</p>
                <div class="form-group row">
                    <label class="col-sm-5 col-form-label">Old Password</label>
                    <div class="col-sm-7">
                        <input type="password" v-model="password.oldPassword" :class="{'is-danger-input': password.errors.has('oldPassword')}" class="form-control" title="oldPassword" placeholder="********">
                        <span class="help is-danger" v-if="password.errors.has('oldPassword')" v-text="password.errors.get('oldPassword')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-5 col-form-label">New Password</label>
                    <div class="col-sm-7">
                        <input type="password" v-model="password.newPassword" :class="{'is-danger-input': password.errors.has('newPassword')}" class="form-control" title="newPassword" placeholder="********">
                        <span class="help is-danger" v-if="password.errors.has('newPassword')" v-text="password.errors.get('newPassword')"></span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-sm-5 col-form-label">Confirm Password</label>
                    <div class="col-sm-7">
                        <input type="password" v-model="password.newPassword_confirmation" :class="{'is-danger-input': password.errors.has('newPassword_confirmation')}" class="form-control" title="newPassword_confirmation" placeholder="********">
                        <span class="help is-danger" v-if="password.errors.has('newPassword_confirmation')" v-text="password.errors.get('newPassword_confirmation')"></span>
                    </div>
                </div>

            </b-container>

            <div slot="modal-footer">
                <button class="btn btn-success float-right" type="submit"><icon name="key"></icon> Update Password</button>
                <button class="btn btn-dark float-right" type="button" style="margin-right: 5px;" @click="$refs.changePassword.hide()"><icon name="times"></icon> Cancel</button>
            </div>
        </b-modal>
        </form>







    </div>
</template>

<script>
  import {Form, Errors} from '@/components/validations/forms';
  import { mapState, mapGetters } from 'vuex'


  import {mixin} from '@/mixins/mixins';
  export default {
    mixins: [mixin],
    name: 'Profile',
    data () {
      return {
        profile: this.$store.getters['user/getProfile'],
        profile2: new Form({}),
        address: this.$store.getters['user/getAddress'],
        address2: new Form({}),
        password: new Form({
          userID : null,
          oldPassword : null,
          newPassword : null,
          newPassword_confirmation : null,
        }),
        account: [],
        unit: null,
        manager: null,
        timezone: null,
        timeformat: null,
        language: null,
        breadcrumbs: [
          {text: 'Home', to: '/dashboard'},
          {text: 'Settings', to: '/settings'},
          {text: 'Manage Profile', active: true},
        ],
      }
    },

    mounted(){
      this.loadProfile()
    },

    methods: {
      test() {
        alert(JSON.stringify(this.$store.getters['environment/getCountries']));
      },

      onProfileSubmit () {
        this.profile2.isDisabled = true;
        this.$store.dispatch('user/updateProfile', this.profile2)
          .then(response => {
            this.profile2.onSuccess(response);
            this.profile2.isDisabled = false;
            this.$snotify.success('Profile Updated Successfully');
              this.$store.dispatch('user/getUserProfile')
                .then(response => {
                  this.profile2 = new Form(JSON.parse(JSON.stringify(this.$store.getters['user/getProfile'])));
                  this.$refs.changeProfile.hide()
                  this.profile = this.$store.getters['user/getProfile'];
                  this.setManager();
                  this.setUnit();
                  this.setTimezone();
                  this.setTimeformat();
                  this.setLanguage();
                })
          })
          .catch(error => {
            this.profile2.onFail(error);
            this.profile2.isDisabled = false;
//            this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
          })
      },

      onAddressSubmit () {
        this.address2.isDisabled = true;
        this.$store.dispatch('user/updateAddress', this.address2)
          .then(response => {
            this.address2.onSuccess(response);
            this.address2.isDisabled = false;
            this.$snotify.success('Address Updated Successfully');
            this.$store.dispatch('user/fetchAddress')
              .then(response => {
                this.address2 = new Form(JSON.parse(JSON.stringify(this.$store.getters['user/getAddress'])));
                this.$refs.changeAddress.hide()
                this.address = this.$store.getters['user/getAddress'];
              })
          })
          .catch(error => {
            alert(JSON.stringify(error));
            this.address2.onFail(error);
            this.address2.isDisabled = false;
//            this.$snotify.error(this.form.errors.error.message, this.form.errors.error.title);
          })
      },

      onPasswordChange () {
        this.password.isDisabled = true;
        this.$store.dispatch('user/updatePassword', this.password)
          .then(response => {
            this.password.onSuccess(response);
            this.password.isDisabled = false;
            this.$snotify.success('Password Updated Successfully');
            this.$refs.changePassword.hide()
          })
          .catch(error => {
            this.password.onFail(error);
            this.password.isDisabled = false;
            this.$snotify.error(this.password.errors.error.message, this.password.errors.error.title);
          })
      },

      loadProfile(){
        this.$store.dispatch('user/getUserProfile')
          .then(response => {
            this.profile = this.$store.getters['user/getProfile'];
            this.profile2 = new Form(JSON.parse(JSON.stringify(this.$store.getters['user/getProfile'])));
            this.profile2.isDisabled = false;
            this.address2 = new Form(JSON.parse(JSON.stringify(this.$store.getters['user/getAddress'])));
            this.address2.isDisabled = false;
            this.password.isDisabled = false;
            this.$store.dispatch('account/fetchAccount', this.$store.getters['user/getProfile'].account)
              .then(response => {
                this.password.userID = this.profile.id;
                this.setManager();
                this.setUnit();
                this.setTimezone();
                this.setTimeformat();
                this.setLanguage();
                this.account = JSON.parse(JSON.stringify(this.$store.state.account.account))
              })
          })
        this.$store.dispatch('user/fetchAddress').then(response => {this.address = this.$store.getters['user/getAddress']})
      },
      setManager () {
        let users = this.managers;
        if(this.profile.manager)
        {
          let manager = this.profile.manager;
          let result = users.filter(function (el) {
            return el.id === parseInt(manager);
          })
          this.manager = result[0].name;
        } else {return null;}

      },
      setTimezone () {
        let timezones = this.timezones;
        let timezone = this.profile.timezone;
        let result = timezones.filter(function (el) {
          return el.id === parseInt(timezone);
        })
        this.timezone = result[0].name;
      },
      setTimeformat () {
        let timeformats = this.timeformats;
        let timeformat = this.profile.timeFormat;
        let result = timeformats.filter(function (el) {
          return el.id === parseInt(timeformat);
        })
        this.timeformat = result[0].name;
      },
      setLanguage () {
        let languages = this.languages;
        let language = this.profile.language;
        let result = languages.filter(function (el) {
          return el.id === parseInt(language);
        })
        this.language = result[0].name;
      },
      setUnit () {
        let units = this.units;
        let assignedUnit = this.profile.units_id;
        let result = units.filter(function (el) {
          return el.id === parseInt(assignedUnit);
        })
        this.unit = result[0].name;
      },

    },

    computed: {
      checkAdmin() {
        return this.$store.state.user.profile.admin;
      },




      company () {
        return this.$store.getters['account/getCompany']
      },

      units () {
        return this.$store.getters['environment/getUnits'];
      },

      timezones () {
        return this.$store.getters['environment/getTimezones'];
      },

      timeformats () {
        return this.$store.getters['environment/getTimeformats'];
      },

      languages () {
        return this.$store.getters['environment/getLanguages'];
      },

      managers () {
        return this.$store.getters['user/getUsers'];
      },





//      profile() {
//        return JSON.parse(JSON.stringify(this.$store.state.user.profile))
//      }

//      ...mapState('user', {
//        profile: state => state.profile,
//      }),

//      ...mapState('user', {
//        profile: state => { return JSON.parse(JSON.stringify(state.profile)); }
//      }),

//      ...mapGetters('user', {
//        profile: 'getProfile',
//      }),
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/settings/profile/profile.vue